(() => {
  if (!customElements.get('add-to-bag-component')) {
    class AddToBagComponent extends HTMLElement {
      constructor() {
        super();

        this.handleButtonClick = () => {
          if (!this.productIsAvailable || this.productIsGiftCard) {
            window.location.href = this.productUrl;
          } else {
            try {
              if (this.isSingleVariant === 'true') {
                handleButtonClick(
                  Number(this.firstVariantId),
                  this.isFinalSale,
                  Number(this.productId)
                );

                const snackbar = new window.Snackbar(
                  'The product is added to bag',
                  window.Snackbar.SUCCESS,
                  2000
                );
                snackbar.show();
              } else {
                this.openBackdrop();
              }
            } catch (error) {
              console.error(error);
            }
          }
        };

        this.handleBackdropClick = (event) => {
          if (event.target === this.backdrop) {
            this.closeBackdrop();
          }
        };

        this.handleCloseClick = () => {
          this.closeBackdrop();
        };

        this.handleProductInfoClick = () => {
          window.location.href = this.productUrl;
        };

        this.handleVariantClick = () => {
          this.closeBackdrop();
        };

        this.handleWrapperClick = (event) => {
          event.stopPropagation();
        };

        this.handleAnimationEnd = () => {
          this.backdrop?.classList.replace('tw-block', 'tw-hidden');
          this.componentWrapper?.classList.remove('tw-animate-slideDown');
        };
      }

      connectedCallback() {
        this.buttonAddToBag = this.querySelector('[data-add-to-bag-component-button]');
        this.backdrop = this.querySelector('[data-add-to-bag-component-backdrop]');
        this.closeBtn = this.querySelector('[data-add-to-bag-component-button-close]');
        this.componentWrapper = this.backdrop?.querySelector('[data-add-to-bag-component-wrapper]');
        this.productInformations = this.querySelector(
          '[data-add-to-bag-component-product-informations]'
        );

        this.variantInsideWrapper = this.componentWrapper?.querySelectorAll(
          '[data-shelf-selector-variant]:not([disabled])'
        );

        this.productIsAvailable = this.getAttribute('data-product-available') === 'true';
        this.productIsGiftCard = this.getAttribute('data-is-gift-card') === 'true';
        this.productUrl = this.getAttribute('data-product-url');

        this.isSingleVariant = this.dataset.isSingleVariant;
        this.firstVariantId = this.dataset.firstVariantId;
        this.productId = this.dataset.productId;
        this.isFinalSale = this.dataset.finalSale === 'true';

        this.bindEvents();
      }

      bindEvents() {
        this.buttonAddToBag.addEventListener('click', this.handleButtonClick);
        this.backdrop?.addEventListener('click', this.handleBackdropClick);
        this.closeBtn?.addEventListener('click', this.handleCloseClick);
        this.productInformations?.addEventListener('click', this.handleProductInfoClick);

        this.variantInsideWrapper?.forEach((button) => {
          button.addEventListener('click', this.handleVariantClick);
        });

        this.componentWrapper?.addEventListener('click', this.handleWrapperClick);
      }

      openBackdrop() {
        this.backdrop?.classList.replace('tw-hidden', 'tw-block');
        this.componentWrapper?.classList.add('tw-animate-slideUp');
        document.body.classList.add('tw-overflow-hidden');
      }

      closeBackdrop() {
        this.componentWrapper?.classList.replace('tw-animate-slideUp', 'tw-animate-slideDown');

        this.componentWrapper?.addEventListener('animationend', this.handleAnimationEnd, {
          once: true,
        });

        document.body.classList.remove('tw-overflow-hidden');
      }

      disconnectedCallback() {
        this.buttonAddToBag.removeEventListener('click', this.handleButtonClick);
        this.backdrop?.removeEventListener('click', this.handleBackdropClick);
        this.closeBtn?.removeEventListener('click', this.handleCloseClick);
        this.productInformations?.removeEventListener('click', this.handleProductInfoClick);

        this.variantInsideWrapper?.forEach((button) => {
          button.removeEventListener('click', this.handleVariantClick);
        });

        this.componentWrapper?.removeEventListener('click', this.handleWrapperClick);
      }
    }

    customElements.define('add-to-bag-component', AddToBagComponent);
  }
})();
